import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const Icon3dPackage: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="3d-package, box"><path d="M12.0018 1.75L20.8785 6.875V17.125L12.0018 22.25L3.125 17.125V6.875L12.0018 1.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M20.8785 6.875L12.0018 12M12.0018 22.25V12M3.125 6.875L12.0018 12" stroke="currentColor" strokeWidth="1.5"/><path d="M7.5625 4.3125L16.4393 9.4375" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default Icon3dPackage;
